"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.POP = exports.PUSH = void 0;
var prop_types_1 = __importDefault(require("prop-types"));
var react_1 = __importDefault(require("react"));
var CSSTransitionGroup_1 = __importDefault(require("react-transition-group/CSSTransitionGroup"));
var TRANSITION_DURATION = 210;
// The available transitions. Must match the class names in CSS.
exports.PUSH = 'push';
exports.POP = 'pop';
/**
 * Wrapper arround react-transition-group with default values.
 */
var Transition = function (_a) {
    var name = _a.name, component = _a.component, className = _a.className, duration = _a.duration, children = _a.children, label = _a.label;
    return (react_1["default"].createElement(CSSTransitionGroup_1["default"], { component: component, transitionEnterTimeout: duration, transitionLeaveTimeout: duration, transitionName: "c-transition-" + name, className: className, "aria-label": label }, children));
};
Transition.propTypes = {
    name: prop_types_1["default"].oneOf([exports.PUSH, exports.POP]).isRequired,
    component: prop_types_1["default"].string,
    className: prop_types_1["default"].string,
    duration: prop_types_1["default"].number,
    children: prop_types_1["default"].node,
    label: prop_types_1["default"].string,
};
Transition.defaultProps = {
    component: 'div',
    children: null,
    className: null,
    duration: TRANSITION_DURATION,
    label: null,
};
exports["default"] = Transition;
